import React from 'react'

interface BalconyIconInterface {
	color?: string
}

export const BalconyIcon = ({ color = '#000033' }: BalconyIconInterface) => {
	return (
		<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4 7.5V6H5.5V7.5H4ZM8.5 7.5V6H10V7.5H8.5ZM0.25 15V9H1V6C1 5.175 1.15625 4.39688 1.46875 3.66563C1.78125 2.93438 2.20938 2.29688 2.75313 1.75313C3.29688 1.20938 3.93438 0.78125 4.66563 0.46875C5.39688 0.15625 6.175 0 7 0C7.825 0 8.60313 0.15625 9.33438 0.46875C10.0656 0.78125 10.7031 1.20938 11.2469 1.75313C11.7906 2.29688 12.2188 2.93438 12.5312 3.66563C12.8438 4.39688 13 5.175 13 6V9H13.75V15H0.25ZM1.75 13.5H3.25V10.5H1.75V13.5ZM4.75 13.5H6.25V10.5H4.75V13.5ZM2.5 9H6.25V1.55625C5.175 1.73125 4.28125 2.23438 3.56875 3.06563C2.85625 3.89688 2.5 4.875 2.5 6V9ZM7.75 9H11.5V6C11.5 4.875 11.1438 3.89688 10.4312 3.06563C9.71875 2.23438 8.825 1.73125 7.75 1.55625V9ZM7.75 13.5H9.25V10.5H7.75V13.5ZM10.75 13.5H12.25V10.5H10.75V13.5Z" fill={color} />
		</svg>
	)
}
